var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"search-book"},_vm._l((_vm.data),function(item,index){return _c('SearchBookItem',{key:index,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }